import { ClientJS } from "clientjs";

export const generateMachineId = () => {
  const client = new ClientJS();
  return client.getFingerprint();
};


export const handleInputChange = (e, setFormData) => {
  const { name, value, type, checked } = e.target;
  setFormData((prev) => ({
    ...prev,
    [name]: type === "checkbox" ? checked : value,
  }));
};


export const resetForm = (setFormData) => {
  setFormData(getInitialFormData());
};

export const getInitialFormData = () => ({
  machine_id: "",
  machine_name: "",
  description: "",
  is_active: true,
});
